import { IconNames } from '@blueprintjs/icons';
import { RadioButtonGroupFormik, type RadioButtonOption } from '@strata/react-radio-button-group';
import { TextWithIcon } from '@strata/react-status-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface PBMOnlySelectorProps {
    onChange?: (value: string) => void;
}

const PBMOnlyOptions = [
    {
        value: 'true',
        component: <TextWithIcon icon={IconNames.SHIELD} text="PBM Only" />,
    },
    {
        value: 'false',
        text: 'PBM & Payer',
    },
] as RadioButtonOption[];

export const PBMOnlySelector = ({ onChange = undefined }: PBMOnlySelectorProps) => {
    const { enableConfidentialPayerRequests } = useFlags();
    return enableConfidentialPayerRequests ? (
        <RadioButtonGroupFormik
            name="pbmOnly"
            label="Request Visibility"
            options={PBMOnlyOptions}
            required
            onChange={onChange}
        />
    ) : null;
};
